(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-hero__slider"] && !Shopify.designMode) return;
  try {
    
  $(document).on('shopify:section:load', function(e){
    let section__id = e.originalEvent.detail.sectionId;

	if ($("#slick__slider_"+section__id+"").hasClass("slick-initialized")){
      $("#slick__slider_"+section__id+"").slick('unslick');
    }

    $("#slick__slider_"+section__id+"").slick({
        dots: false,
        infinite: true,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: 'linear',
        prevArrow:'<button type="button" class="slick-prev pull-left"><svg version="1.2" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><path fill="#FFFFFF" d="M217.8,256.1l127.1,127c9.4,9.4,9.4,24.6,0,33.9c-9.4,9.3-24.6,9.3-34,0l-144-143.9c-9.1-9.1-9.3-23.7-0.7-33.1L310.8,95.1c4.7-4.7,10.9-7,17-7s12.3,2.3,17,7c9.4,9.4,9.4,24.6,0,33.9L217.8,256.1z"/></svg></button>',
        nextArrow:'<button type="button" class="slick-next pull-right"><svg version="1.2" baseProfile="tiny" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><path fill="#FFFFFF" d="M294.1,256L167,129c-9.4-9.4-9.4-24.6,0-33.9s24.6-9.3,34,0L345,239c9.1,9.1,9.3,23.7,0.7,33.1L201.1,417c-4.7,4.7-10.9,7-17,7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6,0-33.9L294.1,256z"/></svg></button>',
      });
  });

  $(document).on('shopify:block:select', function(e){
    let section__id = e.originalEvent.detail.sectionId;
    let block__id = e.originalEvent.detail.blockId;
    console.log(e);

    if ($("#slick__slider_"+section__id+"").hasClass("slick-initialized")){
      $("#slick__slider_"+section__id+"").slick('unslick');
    }

    $("#slick__slider_"+section__id+"").slick({
        dots: false,
        infinite: true,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: 'linear',
        prevArrow:'<button type="button" class="slick-prev pull-left"><svg version="1.2" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><path fill="#FFFFFF" d="M217.8,256.1l127.1,127c9.4,9.4,9.4,24.6,0,33.9c-9.4,9.3-24.6,9.3-34,0l-144-143.9c-9.1-9.1-9.3-23.7-0.7-33.1L310.8,95.1c4.7-4.7,10.9-7,17-7s12.3,2.3,17,7c9.4,9.4,9.4,24.6,0,33.9L217.8,256.1z"/></svg></button>',
        nextArrow:'<button type="button" class="slick-next pull-right"><svg version="1.2" baseProfile="tiny" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><path fill="#FFFFFF" d="M294.1,256L167,129c-9.4-9.4-9.4-24.6,0-33.9s24.6-9.3,34,0L345,239c9.1,9.1,9.3,23.7,0.7,33.1L201.1,417c-4.7,4.7-10.9,7-17,7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6,0-33.9L294.1,256z"/></svg></button>',
    });


	let slicknumber = $(".block__"+block__id+"").attr("data-slick-index");
	console.log(slicknumber);
    $("#slick__slider_"+section__id+"").slick('slickGoTo', slicknumber);
    $("#slick__slider_"+section__id+"").slick('slickSetOption', {'autoplay': false}, true);

  });

  } catch(e) { console.error(e); }
})();
})();
